var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',[_c('a',{attrs:{"href":"https://ieco.io"}},[_c('img',{attrs:{"src":"https://storage.googleapis.com/ieco-communication/logo%2Bdomain.svg"}})]),_c('p',[_vm._v(" El servicio al que estás intentando acceder ha sido deshabilitado. ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }